import type { ConfigurationTemplateFunctionValueWithPosition } from './fieldsHelpers'
import { FunctionValue } from './FunctionValue'
import { TemplateFunctionNameCell } from './TemplateFunctionNameCell'

type Props = {
  data: ConfigurationTemplateFunctionValueWithPosition
  column: number
  row?: number
}

export const TemplateFunctionCell = ({ data, column }: Props) => {
  switch (column) {
    case 0:
      return <TemplateFunctionNameCell data={data} />
    case 1: {
      return <FunctionValue data={data} />
    }
    default:
      return null
  }
}
